import { module } from 'modujs';
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import QuizQuestions from '../vue/components/QuizQuestions'
import QuizResults from '../vue/components/QuizResults'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const that = this;

        this.app = createApp({
            beforeMount() {
                // DEBUG MODE
                // this.showResults = true
                // this.steps = [
                //     {
                //         slug: 'asthma-attack',
                //         value: 1
                //     },
                //     {
                //         slug: 'gina',
                //         value: 5
                //     },
                //     {
                //         slug: 'risk-factors',
                //         value: 1
                //     },
                //     {
                //         slug: 'blood-eosinophil',
                //         value: 2
                //     },
                //     {
                //         slug: 'feno',
                //         value: 3
                //     }
                // ]
            },
            delimiters: ['{(', ')}'],
            data() {
                return {
                    showResults: false,
                    steps: [ // also defines the steps order
                        {
                            slug: 'asthma-attack',
                        },
                        {
                            slug: 'gina',
                        },
                        {
                            slug: 'risk-factors',
                        },
                        {
                            slug: 'blood-eosinophil',
                        },
                        {
                            slug: 'feno',
                        }
                    ]
                }
            },
            computed: {
                formattedSteps() {
                    const formatted = {}
                    for(let step of this.steps) {
                        formatted[step.slug] = step.value
                    }
                    return formatted;
                }
            },
            methods: {
                onSubmit(data) {
                    this.showResults = true;
                },
                onBack() {
                    that.call('goTo', { url: '/'+document.documentElement.getAttribute('lang') }, 'Load')
                },
                onRestart() {
                    this.resetData()
                    this.showResults = false
                },
                resetData() {
                    for(let i = 0; i < this.steps.length; i++) {
                        this.steps[i].value = null
                    }
                }
            }
        })
        this.app.component('quiz-questions', {...QuizQuestions, template: document.getElementById('quiz-questions')})
        this.app.component('quiz-results', { ...QuizResults, template: document.getElementById('quiz-results')})
        this.app.mount(this.el);
    }

    destroy() {
        this.app && this.app.unmount();
    }
}
